import { render, staticRenderFns } from "./home.vue?vue&type=template&id=5deb5dab"
import script from "./home.ts?vue&type=script&lang=js&external"
export * from "./home.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports